import { styled } from 'styled-components';
import React from 'react';
import { theme as ThemeType } from '@motili/ui';

export const styleInput = (theme: typeof ThemeType) => {
    const { textInput } = theme.components;

    return `
      font-family: ${theme.fontFamily('Nunito')};
      border-radius: 0px;
      border-color: ${textInput.borderColor};
      transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;

      /* sm screen */
      font-size: ${textInput.style('font-size', 'sm')};
      font-weight: ${textInput.style('font-weight', 'sm')};
      padding: ${textInput.style('padding', 'sm')};
      height: ${textInput.style('height', 'sm')};
      
      /* md screen */
      @media ${theme.breakpoint('md')} {
          font-size: ${textInput.style('font-size', 'md')};
          font-weight: ${textInput.style('font-weight', 'md')};
          padding: ${textInput.style('padding', 'md')};
          height: ${textInput.style('height', 'md')};
      }
      
      /* lg screen */
      @media ${theme.breakpoint('lg')} {
          font-size: ${textInput.style('font-size', 'lg')};
          font-weight: ${textInput.style('font-weight', 'lg')};
          padding: ${textInput.style('padding', 'lg')};
          height: ${textInput.style('height', 'lg')};
      }
    `;
};
const StyledInputBase = styled.input`
    ${({ theme }) => styleInput(theme)}
`;

export const StyledInput = React.forwardRef<
    HTMLInputElement,
    React.InputHTMLAttributes<HTMLInputElement>
>((props, ref) => <StyledInputBase {...props} ref={ref} />);
